import { QueryIntent } from './queryAnalyzerLLM';
import { FandomSearchResult } from './search';
import { supabase } from '../lib/supabase';

export type SearchProvider = 'exa' | 'perplexity';

// Unified search interface
export interface UnifiedSearchResult {
  overview?: string; // Perplexity provides this
  sources: FandomSearchResult[];
  provider: SearchProvider;
}

// Get the default provider from env or use Perplexity
const DEFAULT_PROVIDER: SearchProvider = 
  (process.env.REACT_APP_SEARCH_PROVIDER as SearchProvider) || 'perplexity';

export async function searchFandom(
  query: string,
  intent: QueryIntent,
  provider: SearchProvider = DEFAULT_PROVIDER
): Promise<UnifiedSearchResult> {
  console.log(`Searching with provider: ${provider}`);
  console.log('Supabase URL:', process.env.REACT_APP_SUPABASE_URL);
  console.log('Calling edge function with:', { query, intent, provider });
  
  try {
    const { data, error } = await supabase.functions.invoke('search', {
      body: {
        query,
        intent,
        provider
      }
    });

    console.log('Edge function response:', { data, error });

    if (error) {
      console.error('Error calling search edge function:', error);
      throw new Error('Failed to search fandom content');
    }

    // The edge function returns sources directly
    return {
      sources: data.sources || [],
      provider: data.provider || provider,
      overview: data.overview // Only Perplexity provides this
    };
  } catch (error) {
    console.error('Error in searchFandom:', error);
    throw new Error('Failed to search fandom content');
  }
}

// Helper to switch providers at runtime
export function setSearchProvider(provider: SearchProvider) {
  // Could store in localStorage or state management
  localStorage.setItem('searchProvider', provider);
}

export function getSearchProvider(): SearchProvider {
  const stored = localStorage.getItem('searchProvider') as SearchProvider;
  return stored || DEFAULT_PROVIDER;
}